import { Box, CircularProgress, Stack } from '@mui/joy';

import RadmelderLogo from '@/assets/logos/radmelder-combo.svg?react';

export function PendingComponent() {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{ backgroundColor: 'neutral.200', minHeight: '100%', display: 'flex', flexDirection: 'column' }}
    >
      <Box sx={{ marginBottom: 4 }}>
        <RadmelderLogo style={{ width: '100%' }} />
      </Box>
      <CircularProgress size="lg" />
    </Stack>
  );
}
